import Styles from "./RA.module.css";
import React, { useEffect, useState, useCallback } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../commons/Accordion";
import { useDispatch, useSelector } from "react-redux";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  getequisitionsBidders,
  getequisitionsList,
  getRaArchive,
} from "../../../Services/ReverseAuction/GetApi";
import { formatDate, formatSlotTime } from "../../../helpers/dateFormat";
import { LeftSideBtns } from "../../Bilateral/LedgerViewContent/ledgerUploadDocs";
import { useLocation } from "react-router-dom";
import { fetchMainScreenActiveConnection } from "../../../Redux/Slices/CapacitySlice";
import LoadMorePagination from "../../LoadeMore";

const LoaderNoData = ({ loading, dataLength }) => {
  if (loading) {
    return (
      <div className={Styles.loaderContainer}>
        <div className={Styles.loader} role="status" aria-label="loading" />
      </div>
    );
  }
  if (!loading && dataLength === 0) {
    return <div className={Styles.noDataContainer}>No records found</div>;
  }
  return null;
};

const SummaryHeader = () => (
  <div className={Styles.accordionSummaryContainer}>
    <table
      className={Styles.summaryTable}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "5%" }} />
        <col style={{ width: "30%" }} />
        <col style={{ width: "25%" }} />
        <col style={{ width: "25%" }} />
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th className={Styles.summaryHeaderCell}>S.No</th>
          <th className={Styles.summaryHeaderCell}>E-Tender Number</th>
          <th className={Styles.summaryHeaderCell}>E RA Number</th>
          <th className={Styles.summaryHeaderCell}>Tender Duration</th>
        </tr>
      </thead>
    </table>
  </div>
);

const SummaryInnerHeader = () => (
  <div
    style={{ marginBottom: "10px" }}
    className={Styles.accordionSummaryContainer}
  >
    <table
      className={Styles.summaryTable}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "10%" }} />
        <col style={{ width: "28%" }} />
        <col style={{ width: "22%" }} />
        <col style={{ width: "22%" }} />
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th className={Styles.summaryInnerHeaderCell}>Start & End Date</th>
          <th className={Styles.summaryInnerHeaderCell}>Start & End Time</th>
          <th className={Styles.summaryInnerHeaderCell}>Req. Qty (MW)</th>
          <th className={Styles.summaryInnerHeaderCell}>Min. Qty (MW)</th>
        </tr>
      </thead>
    </table>
  </div>
);
const SummaryInnerClosedHeader = ({ role }) => (
  <div
    style={{ marginBottom: "10px" }}
    className={Styles.accordionSummaryContainer}
  >
    <table
      className={Styles.summaryTable}
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <colgroup>
        <col style={{ width: "10%" }} />
        <col style={{ width: "28%" }} />
        <col style={{ width: "22%" }} />
        <col style={{ width: "22%" }} />
        <col style={{ width: "22%" }} />
      </colgroup>
      <thead className={Styles.summaryHeader}>
        <tr>
          <th className={Styles.summaryInnerHeaderCell}>Start & End Date</th>
          <th className={Styles.summaryInnerHeaderCell}>Start & End Time</th>
          <th className={Styles.summaryInnerHeaderCell}>Req. Qty (MW)</th>
          <th className={Styles.summaryInnerHeaderCell}>Min. Qty (MW)</th>
          {role === "consumer" ? (
            <th className={Styles.summaryInnerHeaderCell}>
              Selected Bid (MW/3₹(/kWh))
            </th>
          ) : (
            <th className={Styles.summaryInnerHeaderCell}>
              Self Bid (MW/3₹(/kWh))
            </th>
          )}
        </tr>
      </thead>
    </table>
  </div>
);

function formatCustomDate(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${day} ${month} ${year} ${hours}:${minutes}`;
}

const SummaryRow = ({
  ele,
  index,
  expanded,
  onToggle,
  reqData,
  reqLoading,
}) => {
  const showLoader = reqLoading;
  const location = useLocation();
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  )?.toLowerCase();
  const params = new URLSearchParams(location.search);
  let showStatusButtons = params.get("status") === "Closed" ? true : false;

  if (!ele) return null;
  return (
    <div className={expanded === index ? "" : Styles.detailsMainDrop_inactive}>
      <Accordion
        style={{
          backgroundColor: "#f3f5f8",
          marginTop: index === 0 ? "0px" : "3px",
          border:
            expanded === index ? "1px solid var(--primary-color-text)" : "none",
          borderRadius: "10px",
        }}
        expanded={expanded === index}
        onChange={() => onToggle(index)}
      >
        <AccordionSummary
          style={{
            backgroundColor: "white",
            borderRadius: "8px",
          }}
        >
          <div className={Styles.accordionSummaryContainer}>
            <table
              className={Styles.summaryTable}
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <colgroup>
                <col style={{ width: "5%" }} />
                <col style={{ width: "30%" }} />
                <col style={{ width: "25%" }} />
                <col style={{ width: "25%" }} />
              </colgroup>
              <tbody>
                <tr>
                  <td className={Styles.summaryCell}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 6,
                      }}
                    >
                      <ExpandMoreIcon
                        style={{ fontSize: "18px" }}
                        className={`${Styles.expandIconLeft} ${
                          expanded === index ? Styles.rotateIcon : ""
                        }`}
                      />
                      {index + 1}
                    </div>
                  </td>
                  <td className={Styles.summaryCell}>{ele?.tenderNumber}</td>
                  <td className={Styles.summaryCell}>{ele?.auctionNumber}</td>
                  <td className={Styles.summaryCell}>
                    {formatCustomDate(ele?.tenderStartDateTime)} -{" "}
                    {formatCustomDate(ele?.tenderCloseDateTime)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </AccordionSummary>

        <AccordionDetails
          style={{
            backgroundColor: "white",
            borderRadius: "8px",
          }}
        >
          {/* details wrapper: show loader inside this container */}
          <div
            style={{
              border: "1px solid var(--secondary-color-text)",
              margin: "0px 10px 10px 10px",
            }}
            className={Styles.accordionDetailsContainerUploadDocs}
          >
            {showLoader && (
              <div className={Styles.loaderContainer}>
                <div
                  className={Styles.loader}
                  role="status"
                  aria-label="loading connection"
                />
              </div>
            )}
            {!showLoader &&
              (Array.isArray(reqData) && reqData.length ? (
                <>
                  {params.get("status") === "Closed" ? (
                    <SummaryInnerClosedHeader role={role} />
                  ) : (
                    <SummaryInnerHeader />
                  )}

                  <div style={{ padding: "10px" }}>
                    <div
                      style={{
                        border: "1px solid #DFEAF2",
                        padding: "5px",
                        borderRadius: "8px",
                      }}
                    >
                      {params.get("status") === "Closed" ? (
                        <>
                          {role === "consumer" ? (
                            <>
                              {reqData.map((item, idx) => {
                                // Filter bids with winnerBidStatus === "AWARDED"
                                const awardedBids =
                                  item?.bids?.filter(
                                    (bid) => bid.winnerBidStatus === "AWARDED",
                                  ) || [];

                                // If no awarded bids, don't render anything for this item
                                if (awardedBids.length === 0) return null;

                                return (
                                  <React.Fragment key={idx}>
                                    {awardedBids.map((bid, bidIdx) => (
                                      <table
                                        key={`${idx}-${bidIdx}`}
                                        className={Styles.summaryTable}
                                        style={{
                                          tableLayout: "fixed",
                                          width: "100%",
                                        }}
                                      >
                                        <colgroup>
                                          <col style={{ width: "10%" }} />
                                          <col style={{ width: "28%" }} />
                                          <col style={{ width: "22%" }} />
                                          <col style={{ width: "22%" }} />
                                          <col style={{ width: "22%" }} />
                                        </colgroup>
                                        <tbody>
                                          <tr>
                                            <td className={Styles.summaryCell}>
                                              {formatDate(item?.dateStartAt)} -{" "}
                                              {formatDate(item?.dateEndAt)}
                                            </td>
                                            <td className={Styles.summaryCell}>
                                              {formatSlotTime(
                                                item?.slotStartAt,
                                              )}{" "}
                                              -{" "}
                                              {formatSlotTime(item?.slotEndAt)}
                                            </td>
                                            <td className={Styles.summaryCell}>
                                              {item?.requiredQty}
                                            </td>
                                            <td className={Styles.summaryCell}>
                                              {item?.minimumQty}
                                            </td>
                                            <td className={Styles.summaryCell}>
                                              {bid?.selectedQuantity}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    ))}
                                  </React.Fragment>
                                );
                              })}
                            </>
                          ) : (
                            <>
                              {reqData.map((item, idx) => {
                                if (
                                  item?.selfBid?.winnerBidStatus !== "AWARDED"
                                ) {
                                  return null;
                                }

                                return (
                                  <React.Fragment key={idx}>
                                    <table
                                      className={Styles.summaryTable}
                                      style={{
                                        tableLayout: "fixed",
                                        width: "100%",
                                      }}
                                    >
                                      <colgroup>
                                        <col style={{ width: "10%" }} />
                                        <col style={{ width: "28%" }} />
                                        <col style={{ width: "22%" }} />
                                        <col style={{ width: "22%" }} />
                                        <col style={{ width: "22%" }} />
                                      </colgroup>
                                      <tbody>
                                        <tr>
                                          <td className={Styles.summaryCell}>
                                            {formatDate(item?.dateStartAt)} -{" "}
                                            {formatDate(item?.dateEndAt)}
                                          </td>
                                          <td className={Styles.summaryCell}>
                                            {formatSlotTime(item?.slotStartAt)}{" "}
                                            - {formatSlotTime(item?.slotEndAt)}
                                          </td>
                                          <td className={Styles.summaryCell}>
                                            {item?.requiredQty}
                                          </td>
                                          <td className={Styles.summaryCell}>
                                            {item?.minimumQty}
                                          </td>
                                          <td className={Styles.summaryCell}>
                                            {item?.selfBid?.selectedQuantity}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </React.Fragment>
                                );
                              })}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {" "}
                          {reqData.map((item, idx) => {
                            return (
                              <>
                                <table
                                  key={idx}
                                  className={Styles.summaryTable}
                                  style={{
                                    tableLayout: "fixed",
                                    width: "100%",
                                  }}
                                >
                                  <colgroup>
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "28%" }} />
                                    <col style={{ width: "23%" }} />
                                    <col style={{ width: "22%" }} />
                                  </colgroup>
                                  <tbody>
                                    <tr>
                                      <td className={Styles.summaryCell}>
                                        {formatDate(item?.dateStartAt)} -{" "}
                                        {formatDate(item?.dateEndAt)}
                                      </td>
                                      <td className={Styles.summaryCell}>
                                        {formatSlotTime(item?.slotStartAt)} -{" "}
                                        {formatSlotTime(item?.slotEndAt)}
                                      </td>
                                      <td className={Styles.summaryCell}>
                                        {item?.requiredQty}
                                      </td>
                                      <td className={Styles.summaryCell}>
                                        {item?.minimumQty}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </>
                            );
                          })}
                        </>
                      )}

                      {showStatusButtons && (
                        <div
                          style={{ paddingRight: "calc(100vw - 97vw)" }}
                          className={Styles.statusBtnContainer}
                        >
                          <LeftSideBtns showEditDocs={false} clickedIndex={0} />
                        </div>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <div className={Styles.noDataContainer}>
                  No matching records
                </div>
              ))}
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

const RAArchive = ({ type, status }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [reqData, setReqData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reqLoading, setReqLoading] = useState(false);
  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  )?.toLowerCase();
  const userDataKey =
    role === "consumer" ? "capacityGenerator" : "capacityConsumer";
  const [expanded, setExpanded] = useState(0);

  useEffect(() => {
    setExpanded(0);
  }, [type, status]);

  const handleAccordionChange = useCallback(
    (val) => {
      setExpanded((prev) => (prev === val ? -1 : Number(val)));
    },
    [setExpanded],
  );

  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const handleLoadMore = () => setPage((prev) => prev + 1);

  useEffect(() => {
    setExpanded(0);
    setPage(0); // Reset page when filters change
    setData([]); // Clear data when filters change
  }, [type, status]);

  useEffect(() => {
    let mounted = true;
    async function fetchData() {
      try {
        setLoading(true);
        const res = await getRaArchive({ role, status, page: page, size: 10 });
        if (!mounted) return;
        if (res?.data?.code === 200) {
          const newData = res.data.data.page || [];
          setData((prevData) =>
            page === 0 ? newData : [...prevData, ...newData],
          );
          const { totalPages, currentPage } = res.data.data;
          setHasMore(currentPage < totalPages - 1);
        } else {
          setData([]);
          setHasMore(false);
        }
      } catch (error) {
        if (mounted) console.error("Error fetching archive data:", error);
        if (mounted) {
          setData([]);
          setHasMore(false);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    }
    fetchData();
    return () => {
      mounted = false;
    };
  }, [type, status, role, page]);

  const fetchRaReqData = useCallback(
    async ({ id, bidStage }) => {
      try {
        setReqLoading(true);

        if (role === "generator") {
          let res = await getequisitionsBidders(id, bidStage);
          if (res?.data?.code === 200) setReqData(res?.data?.data);
        } else {
          let res = await getequisitionsList(id, bidStage);
          if (res?.data?.code === 200) setReqData(res?.data?.data);
        }
      } catch (error) {
        console.error("Error fetching RA Request Data:", error);
      } finally {
        setReqLoading(false);
      }
    },
    [role],
  );

  useEffect(() => {
    if (!Array.isArray(data) || expanded === -1) return;
    const item = data[expanded];
    const capId = item?.id;
    if (!capId) return;

    fetchRaReqData({
      id: capId,
      bidStage: status === "Closed" ? "AUCTION" : "CB",
    });
    if (status === "Closed") {
      const capId = item?.capacityId;
      dispatch(fetchMainScreenActiveConnection({ capId }));
    }
  }, [data, dispatch, expanded, fetchRaReqData, status]);

  return (
    <>
      <div
        style={{
          height: "calc(100vh - 180px)",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <LoaderNoData loading={loading} dataLength={data?.length ?? 0} />

        <>
          {data?.length > 0 && <SummaryHeader />}
          {
            <LoadMorePagination
              hasMore={hasMore}
              onLoadMore={handleLoadMore}
              loading={loading}
            >
              {" "}
              {data?.map((ele, index) => (
                <SummaryRow
                  key={ele?.id ?? ele?.name ?? index}
                  ele={ele}
                  reqLoading={reqLoading}
                  index={index}
                  reqData={reqData}
                  expanded={expanded}
                  onToggle={handleAccordionChange}
                  userDataKey={userDataKey}
                  role={role}
                />
              ))}
            </LoadMorePagination>
          }
        </>
      </div>
    </>
  );
};

export default RAArchive;
